
<template>
    <div class=" ">
        <div class="employee-attendance-wrapper">

            <div class="clearfix row py-2 mb-2 no-margin">
                <div class="col-sm-4 pl-0">
                    <div class="custom-search">
                        <b-input-group class="mb-0 attendance-search">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>


                <div class="col-sm-8 pl-0 text-right dowload-button-wrapper">
                    <a :href="$api_url+'/employee/attendance/month?export_flg=1&month='+this.month+'&year='+this.year" ><b-icon icon="cloud-download" font-scale="2" class="cursor-pointer" ></b-icon></a>
                </div>
            </div>

            <div class="row py-2 mb-3">
                <div class="col-sm-2 company-form-box-title">
                    Attendance
                </div>

                <div class="col-sm-10 attendance-button-wrapper">

                    <div class="attendance-select-wrapper">
                        <!-- <div class="row">
                            <div class="col-sm-5">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text> Year</b-input-group-prepend>
                                    <b-form-select id="year" name="year" v-model="year" :options="years" @change="reloadData()"></b-form-select>
                                </b-input-group>
                            </div>
                            <div class="col-sm-6">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text> Month </b-input-group-prepend>
                                    <b-form-select id="month" name="month" v-model="month" :options="months" @change="reloadData()"></b-form-select>
                                </b-input-group>
                            </div>
                        </div> -->
                        <b-form-select class="attendance-select" v-model="month" :options="months" @change="reloadData()"></b-form-select>
                        <!-- <b-form-select class="attendance-select" v-model="f_y" :options="$fiscal_years" @change="reloadData()"></b-form-select> -->
                        <b-form-select class="attendance-select" v-model="year" :options="years" @change="reloadData()"></b-form-select>
                    </div>

                    <b-button :href="$api_url+'/employee/attendance/import/template?year='+this.year+'&month='+this.month" v-if="flag != 1"><b-icon icon="code-slash" ></b-icon> Template For Selected Month</b-button>
                    <b-button :href="$api_url+'/employee/attendance/import/template?flg=1'" v-if="flag != 1"><b-icon icon="code-slash" ></b-icon> Template For Today</b-button>
                    <b-button v-if="flag != 1" @click="importAttendances"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>
                </div>
            </div>

            
            <b-modal id="bv-modal-import-attendance" scrollable hide-footer title="Import Attendance" size="lg">
                <div class="my-5"></div>
                <b-overlay :show="showoverlay" rounded="sm" style="min-height: 420px;">
                    <div class="mt-4 employee-tab leave-attendance-dashboard">
                        <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
                            <b-tab title="Template Import">

                                <div class="border-2 border-dashed rounded p-5 text-center mb-3 border-secondary">
                                    <i class="bx bx-cloud-upload font-42 mb-2 text-muted"></i>
                                    <p class="font-14 mb-1 text-muted">Click to browse and select your file</p>
                                    <p class="font-12 text-muted mb-3">Supported: .xlsx, .xls</p>
                                    <label for="templateFile" class="btn btn-primary btn-sm px-4 cursor-pointer mb-0">
                                        Browse File
                                    </label>
                                    <b-form-file id="templateFile" v-model="templateFile" accept=".xlsx,.xls" class="d-none" @change="uploadTemplateFile"></b-form-file>
                                </div>

                                <div v-if="templateFile" class="d-flex align-items-center bg-light border rounded px-3 py-2 mb-3">
                                    <i class="bx bx-spreadsheet text-success font-22 mr-2"></i>
                                    <span class="font-13 text-dark flex-grow-1 text-truncate">{{ templateFile.name }}</span>
                                    <span class="font-11 text-muted mr-3">{{ (templateFile.size / 1024).toFixed(1) }} KB</span>
                                    <b-button size="sm" variant="outline-danger" @click="templateFile = null">
                                        <i class="bx bx-x"></i>
                                    </b-button>
                                </div>

                                <div v-if="templateErrors && templateErrors.length">
                                    <div class="alert alert-danger py-2 font-13">
                                        <i class="bx bx-error-circle mr-1"></i> {{ templateErrors.length }} error(s) found
                                    </div>
                                    <ul class="list-group mb-3" style="max-height:180px; overflow-y:auto;">
                                        <li class="list-group-item list-group-item-danger font-12 py-2"
                                            v-for="(err, i) in templateErrors" :key="i">
                                            {{ err }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="text-center mt-2">
                                    <b-button variant="primary" :disabled="!templateFile || showoverlay" @click="processTemplateImport">
                                        <i class="bx bx-upload mr-1"></i>
                                        {{ showoverlay ? 'Importing...' : 'Import' }}
                                    </b-button>
                                </div>
                            </b-tab>

                            <b-tab title="Device Data Import" v-if="can_upload_device_data">

                                <div class="border-2 border-dashed rounded p-5 text-center mb-3 border-secondary">
                                    <i class="bx bx-cloud-upload font-42 mb-2 text-muted"></i>
                                    <p class="font-14 mb-1 text-muted">Click to browse and select your file</p>
                                    <p class="font-12 text-muted mb-3">Supported: .xlsx, .xls, .csv</p>
                                    <label for="deviceFile" class="btn btn-primary btn-sm px-4 cursor-pointer mb-0">
                                        Browse File
                                    </label>
                                    <b-form-file id="deviceFile" v-model="deviceFile" accept=".xlsx,.xls,.csv" class="d-none" @change="uploadDeviceFile"></b-form-file>
                                </div>

                                <div v-if="deviceFile" class="d-flex align-items-center bg-light border rounded px-3 py-2 mb-3">
                                    <i class="bx bx-file text-info font-22 mr-2"></i>
                                    <span class="font-13 text-dark flex-grow-1 text-truncate">{{ deviceFile.name }}</span>
                                    <span class="font-11 text-muted mr-3">{{ (deviceFile.size / 1024).toFixed(1) }} KB</span>
                                </div>

                                <div v-if="deviceErrors && deviceErrors.length">
                                    <div class="alert alert-danger py-2 font-13">
                                        <i class="bx bx-error-circle mr-1"></i> {{ deviceErrors.length }} error(s) found
                                    </div>
                                    <ul class="list-group mb-3" style="max-height:180px; overflow-y:auto;">
                                        <li class="list-group-item list-group-item-danger font-12 py-2"
                                            v-for="(err, i) in deviceErrors" :key="i">
                                            {{ err }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="text-center mt-2">
                                    <b-button variant="primary" class="text-white" :disabled="!deviceFile || showoverlay" @click="processDeviceImport">
                                        <i class="bx bx-upload mr-1"></i>
                                        {{ showoverlay ? 'Importing...' : 'Import' }}
                                    </b-button>
                                </div>
                            </b-tab>

                        </b-tabs>
                    </div>                    
                </b-overlay>
            </b-modal>




            <div class="row justify-content-center no-margin">

                <div class="col-sm-12  px-0 table-parent">
                    <table class="table attendance-table table-sticky border">
                        <thead class="table-head" style="">
                            <tr>
                                <td class="employee">Employee</td>
                                <td class="" align="center" v-for="(day_details , n) in week_days_header" :key="n" v-bind:style="{ backgroundColor: head_color[day_details.day] }">
                                    <div :title="day_details.title" v-b-tooltip>{{n}}</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(attendance , temp) in paginatedData" :key="attendance.id">
                                <td>{{ attendance.name }} <br/> {{ attendance.employee_code }}</td>
                                <td v-for="(day_details , d) in week_days_header" :key="d" align="center">
                                    <template v-if="month == this_month && year == this_year">
                                        <template v-if="(parseInt(d) <= parseInt(today_index))">

                                            <div v-if="day_details.day == 'weekend' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-info"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                            <div v-else-if="day_details.day == 'holiday' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-success"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                            <div v-else class="">

                                                <template v-if="attendance.attendances_list_by_day[d]">
                                                    <div :id="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date">

                                                        <template v-if="(attendance.attendances_list_by_day[d].auto_checkout == 1)">
                                                            <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                                <b-icon icon="check" font-scale="2" :style="{ color: legend.auto_checkout }"></b-icon>
                                                            </div>
                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                                {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}
                                                                <br /> System Intervened
                                                            </b-tooltip>
                                                        </template>

                                                        <template v-else-if="(attendance.attendances_list_by_day[d].check_in != null &&attendance.attendances_list_by_day[d].check_in != '0' && attendance.attendances_list_by_day[d].checkout != null &&attendance.attendances_list_by_day[d].checkout != '0' && (attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                            <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                                <b-icon icon="check" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                            </div>
                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                                {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}
                                                                <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>                                                         -->
                                                            </b-tooltip>

                                                        </template>

                                                        <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in > 0) || (attendance.attendances_list_by_day[d].early_checkout > 0))">

                                                            <div v-if="attendance.attendances_list_by_day[d].leave_data">

                                                                <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">
                                                                    <b-icon rotate="180" icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                                </template>
                                                                <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">
                                                                    <b-icon icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                                </template>

                                                            </div>
                                                            <div v-else class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                                <b-icon icon="check" font-scale="2" :style="{ color: legend.late_early }"></b-icon>
                                                            </div>


                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                                {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}

                                                                <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                                    <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">On First Half Leave</template>
                                                                    <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">On Second Half Leave</template>
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="attendance.attendances_list_by_day[d].late_check_in > grace_time_late_check_in"> <br /> Late Clock In</template>
                                                                    <template v-if="attendance.attendances_list_by_day[d].early_checkout > grace_time_early_checkout"> <br /> Early Clock Out</template>
                                                                </template>

                                                                <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template> -->
                                                            </b-tooltip>
                                                        </template>

                                                        <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                            <!-- On Leave -->
                                                            <div class="cursor-pointer">
                                                                <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                            </div>
                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                                On Leave
                                                            </b-tooltip>
                                                        </template>
                                                        <template v-else-if="attendance.attendances_list_by_day[d].compen_leave_data">
                                                            <!-- On Compensatory Leave -->
                                                            <div class="cursor-pointer">
                                                                <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                            </div>
                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                                On Compensatory Leave [{{ attendance.attendances_list_by_day[d].compen_leave_data }}]
                                                            </b-tooltip>
                                                        </template>
                                                        <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                            <!-- absent -->
                                                            <div class="cursor-pointer">
                                                                <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                            </div>
                                                            <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">
                                                                {{attendance.attendances_list_by_day[d].comment}}
                                                            </b-tooltip>
                                                        </template>
                                                        <template v-else-if="(attendance.attendances_list_by_day[d].check_in == '00:00:00' || attendance.attendances_list_by_day[d].check_in == null || attendance.attendances_list_by_day[d].check_in == '0') && (attendance.attendances_list_by_day[d].checkout == '00:00:00' || attendance.attendances_list_by_day[d].checkout == null || attendance.attendances_list_by_day[d].checkout == '0') && attendance.attendances_list_by_day[d].absent != 1">

                                                            <!-- Employee absent but didnot apply for a leave -->
                                                            <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>

                                                        </template>
                                                        <template v-else>

                                                            <!-- Employee absent but didnot apply for a leave -->
                                                            <!-- <b-icon icon="blank" variant="" font-scale="1.5"></b-icon> -->
                                                            <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>

                                                        </template>
                                                    </div>

                                                </template>
                                                <template v-else>
                                                    <!-- Employee absent but didnot apply for a leave -->

                                                    <!--<div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>-->
                                                    <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>
                                                    <!--
                                                    <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                                    -->
                                                </template>
                                            </div>

                                        </template>
                                        <template v-else>
                                            <template v-if="attendance.attendances_list_by_day[d] && attendance.attendances_list_by_day[d].compen_leave_data">
                                                <div :id="'f' + attendance.employee_id + attendance.attendances_list_by_day[d].attendances_date" class="cursor-pointer">
                                                    <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                </div>
                                                <b-tooltip :target="'f' + attendance.employee_id + attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                    On Compensatory Leave [{{ attendance.attendances_list_by_day[d].compen_leave_data }}]
                                                </b-tooltip>
                                            </template>
                                            <template v-else-if="attendance.attendances_list_by_day[d] && attendance.attendances_list_by_day[d].leave_data">
                                                <div :id="'f' + attendance.employee_id + attendance.attendances_list_by_day[d].attendances_date" class="cursor-pointer">
                                                    <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                </div>
                                                <b-tooltip :target="'f' + attendance.employee_id + attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                    On Leave
                                                </b-tooltip>
                                            </template>
                                            <template v-else>
                                                <b-icon icon="dash" variant="info" font-scale="2"></b-icon>
                                            </template>
                                        </template>
                                    </template>

                                    <template v-else>

                                        <div v-if="day_details.day == 'weekend' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-info"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                        <div v-else-if="day_details.day == 'holiday' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-success"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                        <div v-else class="">

                                            <template v-if="attendance.attendances_list_by_day[d]">
                                                <div :id="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date">

                                                    <template v-if="(attendance.attendances_list_by_day[d].auto_checkout == 1)">
                                                        <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.auto_checkout }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}
                                                            <br /> System Intervened
                                                        </b-tooltip>
                                                    </template>

                                                    <template v-else-if="(attendance.attendances_list_by_day[d].check_in != null && attendance.attendances_list_by_day[d].check_in != '0' && attendance.attendances_list_by_day[d].checkout != null && attendance.attendances_list_by_day[d].checkout != '0' && (attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                        <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}
                                                            <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                        </b-tooltip>

                                                    </template>

                                                    <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in > 0) || (attendance.attendances_list_by_day[d].early_checkout > 0))">

                                                        <div v-if="attendance.attendances_list_by_day[d].leave_data">

                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">
                                                                <b-icon rotate="180" icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                            </template>
                                                            <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">
                                                                <b-icon icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                            </template>

                                                        </div>
                                                        <div v-else class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.late_early }"></b-icon>
                                                        </div>

                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}
                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                                <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">On First Half Leave</template>
                                                                <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">On Second Half Leave</template>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="attendance.attendances_list_by_day[d].late_check_in > grace_time_late_check_in"> <br /> Late Clock In</template>
                                                                <template v-if="attendance.attendances_list_by_day[d].early_checkout > grace_time_early_checkout"> <br /> Early Clock Out</template>
                                                            </template>

                                                            <!-- <template v-if="attendance.attendances_list_by_day[d].late_check_in > grace_time_late_check_in"> <br /> Late Clock In</template>
                                                                <template v-if="attendance.attendances_list_by_day[d].early_checkout > grace_time_early_checkout"> <br /> Early Clock Out</template>

                                                            <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template> -->
                                                        </b-tooltip>
                                                    </template>

                                                    <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                        <!-- On Leave -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                            On Leave
                                                        </b-tooltip>
                                                    </template>
                                                    <template v-else-if="attendance.attendances_list_by_day[d].compen_leave_data">
                                                        <!-- On Compensatory Leave -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover">
                                                            On Compensatory Leave [{{ attendance.attendances_list_by_day[d].compen_leave_data }}]
                                                        </b-tooltip>
                                                    </template>
                                                    <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                        <!-- absent -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="attendance.employee_id+attendance.attendances_list_by_day[d].attendances_date" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">
                                                            {{attendance.attendances_list_by_day[d].comment}}
                                                        </b-tooltip>
                                                    </template>
                                                    <template v-else-if="(attendance.attendances_list_by_day[d].check_in == '00:00:00' || attendance.attendances_list_by_day[d].check_in == null || attendance.attendances_list_by_day[d].check_in == '0') && (attendance.attendances_list_by_day[d].checkout == '00:00:00' || attendance.attendances_list_by_day[d].checkout == null || attendance.attendances_list_by_day[d].checkout == '0') && attendance.attendances_list_by_day[d].absent != 1">

                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>

                                                    </template>
                                                    <template v-else>

                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>

                                                    </template>
                                                </div>

                                            </template>
                                            <template v-else>
                                                <!-- Employee absent but didnot apply for a leave -->
                                                <!--<div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>-->
                                                <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                            </template>
                                        </div>
                                    </template>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                    <div v-else class="px-3">
                        <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                            <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                                </ul>
                                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <b-modal id="activity_logModal" size="xl" scrollable  hide-footer title="Attendence Info">
                <div class="row no-margin">
                    <div class="col-md-6">
                        <div class="card punch-status">
                            <div class="card-body">
                                <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
                                <div class="punch-det">
                                    <h6>Punch In at</h6>
                                    <p>{{check_in}}</p>
                                </div>
                                <div class="punch-info">
                                    <div class="punch-hours">
                                        <span>{{work_time == '24:00' ? '00:00' : work_time}} hrs</span>
                                    </div>
                                </div>
                                <div class="punch-det">
                                    <h6>Punch Out at</h6>
                                    <p>{{checkout}}</p>
                                </div>
                                <!-- commented out by faroque -->
                                <!-- <div class="statistics">
                                    <div class="row">
                                        <div class="col-md-6 col-6 text-center">
                                            <div class="stats-box">
                                                <p>Break</p>
                                                <h6>{{break_time}} hrs</h6>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-12 text-center">
                                            <div class="stats-box">
                                                <p>Overtime</p>
                                                <h6>{{over_time}} hrs</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <l-a-attendance-updater @onUpdate="getEmployeesAttendance(); $bvModal.hide('activity_logModal')" :date="attendances_date" :employee_id="employee_id"></l-a-attendance-updater>
                    </div>
                    <div class="col-md-6">
                        <div class="card recent-activity">
                            <div class="card-body">
                                <h5 class="card-title">Activity</h5>
                                <ul class="res-activity-list" v-if="activity_log">
                                    <li v-for="(activity, index) in activity_log.split(',')">
                                        <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                        <p class="mb-0" v-else>Punch Out at</p>
                                        <p class="res-activity-time">
                                            <i class="far fa-clock"></i>
                                            {{formateMe(activity) }}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- 17 june 2025 asfaq-->
                    <l-a-outside-activity :attendances_date="attendances_date" :employee_id="employee_id"/>
                    </div>
                </div>
            </b-modal>
            <b-modal id="edit_Modal" size="l" scrollable  hide-footer title="Attendence Info">
                <div class="card border-0 no-shadow">
                    <div class="card-body pt-0">
                        <h5 class="card-title">Timesheet <small class="text-muted">{{edit_date}}</small></h5>
                    </div>
                </div>
                <div class="row no-margin">
                    <div class="col-md-4 pr-2">
                        <div class="btn btn-primary cursor-pointer w-100" @click="addLeave()">Add Leave</div>
                    </div>
                    <div class="col-md-5 pl-2">
                        <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(0)">Add Attendance</div>
                    </div>
                    <div class="col-md-3 pl-2">
                        <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(1)">Resolve</div>
                    </div>
                    <!--<div class="col-md-12 mt-3">
                        <div class="btn btn-primary cursor-pointer w-100" @click="resolve()">Resolve</div>
                    </div>-->
                </div>
            </b-modal>
            <b-modal id="addLeave_Modal" size="xl" scrollable  hide-footer title="Leave Details">
                <employee-leave-details v-if="this.employee_id > 0"  :attendances_date="this.edit_date" v-on:childToParent="reloadData"></employee-leave-details>
            </b-modal>
            <!-- <b-modal id="workedOffsite_Modal" size="xl" scrollable  hide-footer :title="'Resolve : ' + edit_date">
                <worked-offsite v-if="this.employee_id > 0"   :attendances_date="this.edit_date" :resolve_flg="resolve_flg" v-on:childToParent="reloadData"></worked-offsite>
            </b-modal> -->



            <b-modal id="workedOffsite_Modal" size="xl" scrollable  hide-footer :title="'Resolve : ' + edit_date">
                <employee-public-info></employee-public-info>
                <l-a-attendance-updater v-if="employee_id > 0" @onUpdate="reloadData" :date="edit_date"></l-a-attendance-updater>
            </b-modal>
            
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default{

        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;


            }
        },
        props: ['flg' , 'moment'],
        components: { },
        data(){
            const now = new Date();
            return {

                templateFile: null,
                deviceFile: null,
                can_upload_device_data: false,
                templateErrors: [],
                deviceErrors: [],

                showoverlay : false,

                flag : this.flg,
                empfile : null,
                has_file : false,
                upload_url : '',
                process_url : '',

                attendances:[],
                week_days_header:[],
                head_color : {weekend : '#aaaaaa' , holiday : '#aaaaaa'},
                search:'',
                length: 50,
                temp_length: 50,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                ce : true,
                today_index : 0,
                grace_time_late_check_in : 0,
                grace_time_early_checkout : 0,

                blankmsg : 'Fetching data..',
                errormsg : [],

                can_download_template : true,


                attendances_date : null,

                check_in : null,
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,

                edit_date : null,
                employee_id : 0,

                resolve_flg : 0,

                this_month: now.getMonth() + 1,
                this_year: now.getFullYear(),

                month: now.getMonth() + 1,
                year: now.getFullYear(),

                months: [

                    { text: 'January', value: '1' },
                    { text: 'February', value: '2' },
                    { text: 'March', value: '3' },
                    { text: 'April', value: '4' },
                    { text: 'May', value: '5' },
                    { text: 'June', value: '6' },
                    { text: 'July', value: '7' },
                    { text: 'August', value: '8' },
                    { text: 'September', value: '9' },
                    { text: 'October', value: '10' },
                    { text: 'November', value: '11' },
                    { text: 'December', value: '12' }
                ],

                years: [
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],

                legend : {'absent':'#DE0000' , 'late_early': '#BF8F00' , 'ontime': '#18A022' , 'auto_checkout':'#DE0000'},

                // Mustafijur: 06-05-2026
                f_y:'',


            }
        },
        methods:{
            uploadTemplateFile(e) {
                this.templateFile = e.target.files[0];
                this.templateErrors = [];
            },
            uploadDeviceFile(e) {
                this.deviceFile = e.target.files[0];
                this.deviceErrors = [];
            },
            processTemplateImport() {
                if (!this.templateFile) return;
                this.showoverlay = true;
                this.templateErrors = [];
                const data = new FormData();
                data.append('empfile', this.templateFile);
                axios.post(this.upload_url, data, { headers: { 'content-type': 'multipart/form-data' } })
                    .then((response) => {
                        this.has_file = true;

                        if(response.data.status)
                        {
                            this.$bvToast.toast('Valid attendance inputs have been successfully imported and invalid inputs have been ignored.', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                        this.$bvModal.hide('bv-modal-import-attendance');

                            this.reloadData();
                            this.$bvModal.hide('bv-modal-import-attendance');
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                        this.showoverlay = false;
                    })
                    .catch(() => { this.showoverlay = false; });
            },
            processDeviceImport() {
                if (!this.deviceFile) return;
                this.showoverlay = true;
                this.deviceErrors = [];
                const data = new FormData();
                data.append('empfile', this.deviceFile);
                data.append('k', 1);
                axios.post(this.upload_url, data, { headers: { 'content-type': 'multipart/form-data' } })
                    .then((response) => {
                        this.has_file = true;

                        if(response.data.status)
                        {
                            this.$bvToast.toast('Valid attendance inputs have been successfully imported and invalid inputs have been ignored.', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                            this.reloadData();
                            this.$bvModal.hide('bv-modal-import-attendance');
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                        this.showoverlay = false;
                    })
                    .catch(() => { this.showoverlay = false; });
            },

            // Mustafijur: 06-05-2026: Starts
            getEmployeesAttendanceNew: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                var today = new Date();

                let month = this.month;
                let year = this.year;
                let fiscal_year = this.f_y;
                let years = fiscal_year.split('-');

                //if ((today.getMonth() + 1) <= 6) year = years[0];
                if (month <= 6) year = years[1];
                else year = years[0];

                this.year = year;



                if((today.getFullYear() == year) && (month > (today.getMonth() + 1)))
                {
                    this.can_download_template = false;

                    this.month = (today.getMonth() + 1);

                    currentObj.$bvToast.toast("Future date can't be accessed!", {
                                        title: `Warning`,
                                        variant: 'warning',
                                        solid: true
                                    });

                    return false;
                }
                else
                {
                    this.can_download_template = true;;
                }


                axios.get(this.pageurl+'/employee/attendance/month' , {
                    params: {
                        month: month,
                        year: year,
                        export_flg : 0,
                    }
                }).then(function(response){
                    this.attendances = response.data.attendances_list;
                    this.can_upload_device_data = response.data.can_upload_device_data;

                    if(this.attendances.length == 0)
                        this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


                    this.week_days_header = response.data.week_days_header;
                    this.head_color = response.data.head_color;

                    this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.attendances.length, text: "All" }
                                                ];
                    this.people = this.attendances.length;

                    this.today_index = response.data.today_index;

                    this.grace_time_late_check_in = response.data.grace_time_late_check_in;
                    this.grace_time_early_checkout = response.data.grace_time_early_checkout;



                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            // Mustafijur: 06-05-2026: Ends

            setUrls:function()
            {
                this.upload_url = this.$api_url+"/employee/attendance/import";
                this.process_url = this.$api_url+'/employee/attendance/import/process';

            },

            // Added by sohel
            importAttendances: function()
            {
                this.$bvModal.show('bv-modal-import-attendance');
            },


            /********************* */
            reloadData: function()
            {
                this.resolve_flg = 0;
                this.$bvModal.hide('edit_Modal');
                this.$bvModal.hide('addLeave_Modal');
                this.$bvModal.hide('workedOffsite_Modal');
                this.getEmployeesAttendance();
            },
            resetdata : function()
            {
                this.attendances_date = null;
                this.check_in = null;
                this.checkout = null;
                this.work_time = 0;
                this.break_time = 0;
                this.over_time = 0;
            },
            convertMinsToHrsMins: function (minutes) {

                /*if(ins.checkout == '00:00:00')
                    return '..';*/


                var h = Math.floor(minutes / 60);
                var m = minutes % 60;
                h = h < 10 ? '0' + h : h;
                m = m < 10 ? '0' + m : m;
                return h + ':' + m;
            },
            formateMe :function(minutes){

                if(minutes == '00:00:00' || minutes == null || minutes == '0') return '..';

                return moment(minutes, "hh:mm").format('LT');
            },
            showActivity : function(ins)
            {
                this.resetdata();

                this.attendances_date = moment(String(ins.attendances_date)).format('YYYY-MM-DD ');
                this.check_in = moment(ins.check_in, "hh:mm").format('LT');

                if(ins.checkout != '00:00:00' || ins.checkout != null)
                    this.checkout = moment(ins.checkout, "hh:mm").format('LT');
                else
                    this.checkout = '..';

                this.work_time = this.convertMinsToHrsMins(ins.work_time);
                this.break_time = this.convertMinsToHrsMins(ins.break_time);
                this.over_time = this.convertMinsToHrsMins(ins.over_time);

                this.activity_log = ins.activity_log;
                this.employee_id = ins.employee_id; // 17 june 2025 asfaq

                this.$bvModal.show('activity_logModal');

            },
            showResolve : function(employee_id , d)
            {
                this.resetdata();
                this.setEmployee(employee_id);
                this.edit_date = moment(String(d)).format('YYYY-MM-DD');
                this.employee_id = employee_id;
                this.$bvModal.show('edit_Modal');
            },
            addLeave : function()
            {
                //this.employee_id

                this.$bvModal.hide('edit_Modal');
                this.$bvModal.show('addLeave_Modal');


            },
            workedOffsite : function(x)
            {
                this.resolve_flg = x;
                this.$bvModal.hide('edit_Modal');
                this.$bvModal.show('workedOffsite_Modal');
            },
            resolve : function()
            {

            },
            setEmployee(x)
            {
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {
                       return;

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },

            getEmployeesAttendance: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                this.showoverlay = true;

                var today = new Date();

                let month = this.month;
                let year = this.year;
                let fiscal_year = this.getCurrentFinancialYear();
                this.f_y = this.getCurrentFinancialYear(); // Mustafijur: 06-05-2026
                let years = fiscal_year.split('-');

                //if ((today.getMonth() + 1) <= 6) year = years[0];
                // if (month <= 6) year = years[1];
                // else year = years[0];

                // this.year = year;



                if((today.getFullYear() == this.year) && (month > (today.getMonth() + 1)))
                {
                    this.can_download_template = false;

                    this.month = (today.getMonth() + 1);

                    currentObj.$bvToast.toast("Future date can't be accessed!", {
                                        title: `Warning`,
                                        variant: 'warning',
                                        solid: true
                                    });

                    return false;
                }
                else
                {
                    this.can_download_template = true;;
                }
                this.attendances = [];
                currentObj.showoverlay = true;
                axios.get(this.$api_url+'/employee/attendance/month' , {
                    params: {
                        month: month,
                        year: year,
                        export_flg : 0,
                    }
                }).then(function(response){
                    this.attendances = response.data.attendances_list;
                    this.can_upload_device_data = response.data.can_upload_device_data;

                    if(this.attendances.length == 0)
                        this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


                    this.week_days_header = response.data.week_days_header;
                    this.head_color = response.data.head_color;

                    this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.attendances.length, text: "All" }
                                                ];
                    this.people = this.attendances.length;

                    this.today_index = response.data.today_index;

                    this.grace_time_late_check_in = response.data.grace_time_late_check_in;
                    this.grace_time_early_checkout = response.data.grace_time_early_checkout;

                    currentObj.showoverlay = false;

                }.bind(this)).catch(function (error){
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);});


            },
            setFirstPage :  function()
            {
                this.pagination.currentPage = 1;
                this.length = this.temp_length;
            },

            downloadData : function()
            {
                if(this.attendances.length > 0)
                {
                    if(!this.checkNet()) return false;
                    let currentObj = this;
                    this.showoverlay = true;
                    axios.get(this.$api_url+'/employee/attendance/month' , {
                        params: {
                            month: this.month,
                            year: this.year,
                            export_flg : 1,
                        }
                    }).then(function(response){
                        //this.attendances = response.data.attendances_list;

                        if(response.data.attendances_list == 0)
                            this.blankmsg = "Looks like you have not added any employee attendance yet.";

                            currentObj.showoverlay = false;
                    }.bind(this)).catch(function (error){ currentObj.serverError(error);currentObj.showoverlay = false;});
                }
            }


        },
        created: function(){

            this.getEmployeesAttendance();
            this.setUrls();

        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.attendances;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },


        }
    }
</script>
<style scoped>

.table-sticky{
    position: relative;
}
.table-sticky thead td {

    position: sticky;
    top: 0;
    background: #CCF4FE;
    z-index: 9;
}
.table-parent{
    height: 100vh;
    overflow: auto;

}
</style>
